import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  MenuItem,
  Grid,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function AddNotificationPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    user: "",
    title: "",
    message: "",
    eventType: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    alert("✅ Notification saved (visual only)");
  };

  const handleCancel = () => {
    navigate("/notifications");
  };

  return (
    <Box
      p={5}
      display="flex"
      justifyContent="center"
      alignItems="flex-start"
      sx={{ minHeight: "90vh", backgroundColor: "#f9f9f9" }}
    >
      <Paper
        elevation={4}
        sx={{
          p: 4,
          width: "70%",
          display: "flex",
          flexDirection: "column",
          borderRadius: 3,
          backgroundColor: "#fff",
        }}
      >
        {/* Header */}
        <Typography variant="h5" fontWeight="600" mb={3}>
          Add Notification
        </Typography>
	<Typography variant="body2" color="text.secondary" mb={3}>
          Notify another team member about anything.
        </Typography>

        {/* Vertically Aligned Form */}
        <Grid container spacing={3} direction="column">
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="User"
              name="user"
              value={formData.user}
              onChange={handleChange}
              variant="outlined"
            >
              <MenuItem value="manager1">Manager 1</MenuItem>
              <MenuItem value="rep1">Rep 1</MenuItem>
              <MenuItem value="rep2">Rep 2</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={6}
              label="Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Event Type"
              name="eventType"
              value={formData.eventType}
              onChange={handleChange}
              variant="outlined"
            >
              <MenuItem value="lead">Lead</MenuItem>
              <MenuItem value="task">Task</MenuItem>
              <MenuItem value="followup">Follow Up</MenuItem>
              <MenuItem value="system">System</MenuItem>
            </TextField>
          </Grid>
        </Grid>

        {/* Buttons */}
        <Box display="flex" justifyContent="flex-end" mt={4} gap={2}>
          <Button
            variant="outlined"
            color="inherit"
            onClick={handleCancel}
            sx={{ width: 150 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            sx={{ width: 180 }}
          >
            Save Notification
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
